import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Modal from 'components/common/Modal';

const Instructions = ({ children, onClose }) => {
    const { t } = useTranslation();

    return (
        <Modal closeModal={onClose} title={t('instruction.title')} fullscreen>
            <div className="base-margin">
                {children}
                <button
                    className="base-margin button button--black button--block"
                    onClick={onClose}
                    type="button"
                >
                    {t('instruction.start')}
                </button>
            </div>
        </Modal>
    );
};

Instructions.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func,
};

export default Instructions;
